"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const roomViewStore_1 = require("@/room/room_view/roomViewStore");
const react_i18next_1 = require("react-i18next");
const svgs_1 = require("@@/assets/svgs");
const functions_1 = require("@/common/functions");
const string_utils_1 = require("@/common/string_utils");
const Button_1 = __importDefault(require("@mui/material/Button"));
function default_1({ isPreview }) {
    const isLoggedIn = (0, react_redux_1.useSelector)((state) => { var _a; return (_a = state.whoAmI) === null || _a === void 0 ? void 0 : _a.is_logged_in; });
    const roomId = (0, react_redux_1.useSelector)((state) => state.roomData.id);
    const likeCounts = (0, react_redux_1.useSelector)((state) => state.roomData.like_counts);
    const hasLike = (0, react_redux_1.useSelector)((state) => state.roomData.has_like);
    const dispatch = (0, react_redux_1.useDispatch)();
    const dispatchLikeStateChange = (liked) => dispatch((0, roomViewStore_1.setLikeStates)(liked));
    const [pending, setPending] = (0, react_1.useState)(false);
    const onLikeClick = () => {
        if (!isPreview && !pending) {
            (0, functions_1.changeLikeState)({
                isLoggedIn,
                setPending,
                roomId,
                onLikeChanged: dispatchLikeStateChange,
            });
        }
    };
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(Button_1.default, Object.assign({ fullWidth: true, sx: {
            columnGap: '4px',
            height: '40px',
            p: 0,
            borderRadius: '8px',
            border: '1px solid var(--gray-10)',
            lineHeight: 1,
            color: 'var(--gray-80)',
            bgcolor: 'var(--white) !important',
        }, onClick: onLikeClick }, { children: [(0, jsx_runtime_1.jsx)(svgs_1.LikeHeartOutlined16Svg, { css: {
                    path: {
                        transition: 'all 0.15s ease',
                        fill: hasLike ? '#EB5757' : 'black',
                        fillOpacity: hasLike ? 1 : 0,
                        strokeWidth: hasLike ? 0 : 1.5,
                        stroke: 'black',
                        cursor: 'pointer',
                    },
                } }), (0, jsx_runtime_1.jsxs)("div", Object.assign({ css: { fontSize: '15px' } }, { children: [t('찜'), "\u00A0", (0, string_utils_1.money)(Number(likeCounts)), t('개')] }))] })));
}
exports.default = default_1;
